<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import { enhance } from '$app/forms';
	import Loader from '$ravioli/lib/components/Loader.svelte';
	import logo from '$ravioli/lib/assets/images/logo.png';
	import instagram from '$ravioli/lib/assets/icons/instagram.svg';
	import facebook from '$ravioli/lib/assets/icons/facebook.svg';
	import whatsapp from '$ravioli/lib/assets/icons/whatsapp-red.svg';
	import youtube from '$ravioli/lib/assets/icons/youtube.svg';

	let year = new Date().getFullYear();
	let formLoading = false,
		showMessage = false;
</script>

<section class=" font-roboto bg-[#FCF6ED] px-6 py-11 md:py-14">
	<div class="mx-auto max-w-[754px]">
		<div class="flex flex-col gap-4 md:gap-[18px]">
			<ImageOptimiser
				src={logo}
				alt="Logo"
				imageSourceType="internal"
				classes={{ image: 'max-w-[100px] md:max-w-[112px] mx-auto' }}
			/>
			<p class="text-center font-medium md:text-[28px]">
				“Flavour-Packed Freshness, Meals for a Better You”
			</p>
		</div>
		<div class="mt-8 flex flex-col gap-8 md:mt-12 md:gap-12">
			<ul class="flex justify-center gap-6 md:gap-8">
				<li>
					<a target="_blank" href="https://www.instagram.com/raviolifitfoods/">
						<img src={instagram} alt="instagram" class="w-7 h-7 md:w-8 md:h-8" />
					</a>
				</li>
				<li>
					<a target="_blank" href="https://www.facebook.com/raviolifitfoods/">
						<img src={facebook} alt="facebook" class="w-7 h-7 md:w-8 md:h-8" />
					</a>
				</li>
				<li>
					<a
						target="_blank"
						href="https://api.whatsapp.com/send/?phone=918297761289&text&type=phone_number&app_absent=0"
					>
						<img src={whatsapp} alt="whatsapp" class="w-7 h-7 md:w-8 md:h-8" />
					</a>
				</li>
				<li>
					<a target="_blank" href="http://www.youtube.com/@VijayMangamFatLossExpert">
						<img src={youtube} alt="youtube" class="w-7 h-7 md:w-8 md:h-8" />
					</a>
				</li>
			</ul>
			{#if formLoading || showMessage}
				{#if showMessage}
					<p class="mt-4 text-center text-lg font-medium text-[#ed292d]">
						Thank you for subscribing!
					</p>
				{:else}
					<div class="flex justify-center">
						<Loader loaderColor="#ed292d" classes="w-6 h-6 mt-4" />
					</div>
				{/if}
			{:else}
				<form
					method="POST"
					action="/?/submitLead"
					use:enhance={() => {
						formLoading = true;
						return async ({ result }) => {
							formLoading = false;
							if (result.data.responseStatus === 202) {
								showMessage = true;
							}
						};
					}}
					class="mt-3 flex flex-col items-center justify-center md:mt-5 md:gap-4"
				>
					<p class="text-center font-medium">Subscribe to our emails</p>
					<div class="flex w-full flex-col gap-4 pt-3 md:pt-0 md:mx-auto md:max-w-[435px] md:flex-row md:gap-5">
						<input
							type="email"
							name="email"
							placeholder="Email"
							id="email"
							class="flex-auto rounded-lg border-[0.5px] border-[#E9E8E7] px-4 py-2 focus:outline-none"
						/>
						<button
							type="submit"
							class="mx-auto mt-1 w-fit rounded-lg bg-[#ED292D] px-7 py-2 font-medium text-white"
							>Subscribe</button
						>
					</div>
				</form>
			{/if}
			<div class="mt-2 flex flex-wrap justify-center gap-3">
				<a href="/disclaimer">Disclaimer</a>
				<a href="/privacy-policy">Privacy Policy</a>
				<a href="/terms-and-conditions">Terms & Conditions</a>
				<!-- <a href="">Shipping Policy</a> -->
				<a href="/refund-policy">Refund Policy</a>
				<a href="/contact-us">Contact Us</a>
				<a href="/about-us">About Us</a>
			</div>
			<div class="flex w-full max-w-[1070px] flex-col items-center md:flex-row md:justify-between ">
				<p>
					&copy; {year} <span class="font-medium">Ravioli Fit Foods.</span> All rights reserved.
				</p>
				<a target="_blank" href="https://www.apexcommerce.com?utm_source=ravioli&utm_medium=ravioli_website&utm_campaign=powered_by_apex" class=" text-iris_primary text-base font-normal md:my-8">
					Powered by <strong>www.apexcommerce.com</strong>
				</a>
			</div>
		</div>
	</div>
</section>
